import { render, staticRenderFns } from "./ScreeningsUpdatePCBScreeningSchema.vue?vue&type=template&id=29507ec4&scoped=true&"
import script from "./ScreeningsUpdatePCBScreeningSchema.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdatePCBScreeningSchema.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdatePCBScreeningSchema.vue?vue&type=style&index=0&id=29507ec4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29507ec4",
  null
  
)

export default component.exports